// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion_Accordion__Y6LF4","Accordion_ref":"Accordion_Accordion_ref__FHD__","Accordion_heading":"Accordion_Accordion_heading__SsJrk"};